import { FormModel, FormModelEdit } from '@ikegps/core-shared';
import { action, makeObservable } from 'mobx';
import { IkeInputStateGroup } from '../components/input/input.state.group';
import { FormModelEditState } from '../store/form.edit.model';
import { MobxState } from './mobx';

export class FormEditState extends MobxState {
	formRevision: string;

	editState: FormModelEditState;
	form: FormModelEdit<FormModelEditState>;

	inputStates: IkeInputStateGroup = new IkeInputStateGroup();

	constructor(form: FormModel) {
		super();
		makeObservable(this);

		this.formRevision = form.revision;
		this.editState = new FormModelEditState(form);
		this.form = new FormModelEdit(form, this.editState);
	}

	@action reset(): void {
		this.editState.reset();
	}

	@action revert(fieldId: string) {
		this.editState.fields.delete(fieldId);
	}

	@action discard() {
		if (this.editState != null) {
			this.editState.reset();
		}
	}

	isFieldDirty(fieldId: string) {
		return this.editState.fields.has(fieldId);
	}

	get isDirty(): boolean {
		return this.editState.isDirty;
	}

	get isValid(): boolean {
		return this.inputStates.isValid;
	}

	get canSubmit(): boolean {
		return this.inputStates.canSubmit;
	}
}
